const Chosen = require('./common/chosen');
const CollapsibleFieldset = require('./common/collapsiblefieldset');
const CanonicalPhonenumber = require('./common/canonical-phonenumber');
const Modal = require('./common/modal');

const OrtsListe = require('./verwaltung/orts-liste');
const OrtsEditor = require('./verwaltung/orts-editor');
const VereinsEditor = require('./verwaltung/vereins-editor');
const VereinsListe = require('./verwaltung/vereins-liste');
const WrListe = require('./verwaltung/wr-liste');
const WrEditor = require('./verwaltung/wr-editor');
const TSO = require('./verwaltung/tso');
const Dashboard = require('./common/dashboard');
const VeranstaltungsListe = require('./zwe/veranstaltungs-liste');
const VeranstaltungsEditor = require('./zwe/veranstaltungs-editor');
const Vergabezeitraum = require('./zwe/vergabezeitraum');
const EinsatzPlaner = require('./zwe/einsatz-planer');
const Emailer = require('./zwe/emailer');
const Mailtext = require('./system/mailtext');
const SysBenutzerListe = require('./system/sysbenutzer-liste');
const EsvVereinsdaten = require('./system/esv-vereinsdaten');
const EsvLizenzdaten = require('./system/esv-lizenzdaten');
const QueueEntries = require('./system/queue-entries');
const Tabs = require('./common/tabs');

function Application() {
	Chosen.init();
	CollapsibleFieldset.init();
	CanonicalPhonenumber.init();
	Modal.init();
	Tabs.init();

	return {
		OrtsListe: OrtsListe,
		OrtsEditor: OrtsEditor,
		VereinsEditor: VereinsEditor,
		VereinsListe: VereinsListe,
		WrListe: WrListe,
		WrEditor: WrEditor,
		TSO: TSO,
		Dashboard: Dashboard,
		VeranstaltungsListe: VeranstaltungsListe,
		VeranstaltungsEditor: VeranstaltungsEditor,
		Vergabezeitraum: Vergabezeitraum,
		EinsatzPlaner: EinsatzPlaner,
		Emailer: Emailer,
		Mailtext: Mailtext,
		SysBenutzerListe: SysBenutzerListe,
		EsvVereinsdaten: EsvVereinsdaten,
		EsvLizenzdaten: EsvLizenzdaten,
		QueueEntries: QueueEntries,
		Tabs: Tabs,
	}
}

module.exports = Application;
